module.exports = __webpack_public_path__ + "media/images/icons/auth_warning-770354d89cddef350851e011dd6c7e6f.svg";